import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  attributeList: [],
  loading: false,
  error: undefined,
};

const attributeSlice = createSlice({
  name: 'attribute',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setAttributeList(state, action) {
      const { data, inForm } = action.payload;
      const propName = inForm ? `${inForm}Filters` : 'attributeList';
      state[propName] = data?.map((item, index) => {
        return { ...item, key: index };
      });
      state.loading = false;
      state.error = undefined;
    },
    filterAttributes(state, action) {
      state.attributeList = state.attributeList?.filter((attribute) =>
        attribute.includes(action)
      );
      state.loading = false;
    },
    clearAttributeList(state, action) {
      const payload = action?.payload;
      const propName = payload ? `${payload}Filters` : 'attributeList';
      state[propName] = [];
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const attributeActions = attributeSlice.actions;

export default attributeSlice.reducer;
